export default __webpack_public_path__ + "static/media/painoient1.ad57d5af.jpeg";